export default function setCartWidgetOffset(offset = 0) {
  document.documentElement.style.setProperty(
    '--bubble-widget-offset-bottom',
    `${offset}px`
  )
  window.dispatchEvent(new Event('bubble:position:update'))
}
